export default __webpack_public_path__ + "static/media/rider-icon.078c2235.svg";